<template>
  <div class="post-description">
    <div class="header">
      <!-- <h4 class="name">{{post.name}}</h4> -->
      <p class="name">
        <template v-if="likes_description">
          {{$tc('video_watch.interactions.likes', mutableLikes || 0, {likes: $n(mutableLikes || 0)})}} 
        </template>
      </p>

      <div style="display: flex; height: fit-content;">
        <Like style="margin-inline: 7.5px;" @toggleLike="toggleLike" :liked="liked" v-if="enable_likes" />
        <CommentButton v-if="SHOW_COMMENT" style="margin-inline: 7.5px;" :post="post" :model="model" />
        <SocialShare v-if="showSocialShare" style="margin-inline: 7.5px;" :sharing="{ url: shareUrl }" />
        <SendTokensToModelButton v-if="showTokens" :model="model" :post="post" style="margin-inline: 7.5px;"  />
      </div>
    </div>

    <p class="description">{{post.description}}</p>
  </div>
</template>

<script>
import SendTokensToModelButton from "../../components/CallToAction/ButtonSendTokensToModel";
import SocialShare from "../../components/CallToAction/SocialShare";
import Like from "../../components/CallToAction/Like";
import CommentButton from "../Comment/Button.vue";

import resources from "../../resources";

const SHOW_SOCIAL_SHARE = process.env.VUE_APP_ENABLE_SSR_LINK === "true";

export default {
  name: "PostDescription",
  components: {
    SendTokensToModelButton,
    SocialShare,
    Like,
    CommentButton
},
  props: {
    post: {},
    model: {},
  },
  data() {
    return {
      shareUrl: `${document.location.origin}/@${this.model.username}/post/${this.post.post_id}`,
      mutableLikes: JSON.parse(this.post.likes) || 0,
      showSocialShare: SHOW_SOCIAL_SHARE,
    };
  },
  methods: {
    toggleLike(value) {
      if (Object.keys(this.post) == 0 || Object.keys(this.model) == 0) return;

      this.mutableLikes = value ? this.mutableLikes + 1 : (this.mutableLikes || 1) - 1;

      resources.postLike.toggleLike({ postID: this.post.post_id });
    },
  },
  computed: {
    liked() {
      return this.post.interaction.liked;
    },
    likes_description(){
      return this.mutableLikes > 0 && this.enable_likes;
    },
    enable_likes() {
      return this.post.interaction && this.post.interaction.likes_enabled;
    },
    SHOW_COMMENT() {
      return this.post.available;
    },
    showTokens() {
      return this.post.front_container && this.post.front_container !== "tokens";
    },
  }
};
</script>
<style lang="scss" scoped>
@import "../../styles/variables";

.post-description {
  margin: 10px 5px;
  text-align: left;
  // min-height: 50px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-direction: normal;

    width: 100%;
    -webkit-box-orient: horizontal;
    -ms-flex-direction: row;
    flex-direction: row;
  }

  .name {
    margin: auto 0 3px 0;
    text-transform: capitalize;
  }

  .description {
    margin: 0.5em 0 0 0;
    color: var(--pallete_clear_text_color);
  }
}
</style>
